import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ScheduledReportInput = () => {
  const { scheduledReportId = '' } = useParams();
  const decodedId = scheduledReportId ? atob(scheduledReportId) : scheduledReportId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'scheduledReport';

  useEffect(() => {
    if (scheduledReportId) { setIsEditing(true); fetchDetails(); }
  }, [scheduledReportId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['scheduledReport'] + id + '/', { headers });
      const d = response.data;
      setFormData({
        ...d,
        report: d.report?.id ?? d.report,
        recipients: Array.isArray(d.recipients) ? d.recipients.map(r => r?.id ?? r) : d.recipients,
      });
    } catch (error) { console.error('Error fetching Scheduled Report details:', error); }
  };

  const fields = [
    {
      name: 'report',
      label: 'Report',
      type: 'async-select',
      required: true,
      endpoint: API_ROUTES.report,
      getOptionLabel: (r) => r.name,
    },
    {
      name: 'delivery_schedule',
      label: 'Delivery Schedule',
      type: 'text',
      required: true,
      placeholder: 'e.g. Daily, Weekly, cron expression',
    },
    {
      name: 'format',
      label: 'Format',
      type: 'select',
      required: true,
      options: [
        { value: 'pdf', label: 'PDF' },
        { value: 'csv', label: 'CSV' },
        { value: 'xlsx', label: 'Excel' },
      ],
    },
    {
      name: 'recipients',
      label: 'Recipients',
      type: 'async-multiselect',
      required: true,
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Scheduled Report' : 'Create Scheduled Report'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/scheduled-report/list" />
    </div>
  );
};

export default ScheduledReportInput;